var _module_exports = "<button class=\"btn btn-select\">\n\t<span class=\"icon icon-split-lg\"></span><span ng-show=\"vm.label\">{{vm.label}}</span>\n</button>";;
var path = '/public-client/templates/breakout-selector.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;